module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Bold.3b34ef0.ttf";